/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_REPORT6 } from "./actionTypes"
import { listReport6Error, listReport6Success } from "./actions"

//Include Both Helper File with needed methods
import { report6NewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(report6NewApi, request.payload.form)
    if (response === undefined) throw new Error("API error")
    yield put(listReport6Success(response))
  } catch (error) {
    console.log(error.message)
    yield put(listReport6Error(error.message))
  }
}

function* report6ListSaga() {
  yield takeEvery(LIST_REPORT6, list)
}

export default report6ListSaga
